/**
 * Classe astratta per l'implementazione di una migrazione
 */
export abstract class MigrationFunction<T> {
  readonly name: string = this.constructor.name;
  public logs: { message: string; data?: any }[] = [];
  abstract readonly versionId: number;

  abstract run(data: T): void;

  log(message: string, data?: any) {
    this.logs.push({ message, data });
  }
}
